'use strict';

/*global _locale*/

function initialize($wrapper) {
  $wrapper.find('.searchSelect').selectpicker({
    style: 'btn-default',
    liveSearch: true
  });

  $wrapper.find('.loadOtherItems').k2_loadOtherItems();
  $wrapper.find('.char-counter').k2_charCounter();
  $wrapper.find('.table').k2_tableCollapsible();
  $wrapper.find('.js-datepicker').datepicker({ language: _locale });
}

$(document).ready(function () {
  initialize($('body'));
});
